module.exports = __webpack_public_path__ + "img/LOGO-OUB.7f7298b2.svg";